<template>
  <v-flex class="controls">
    <v-flex class="control-settings" d-flex justify-center align-center>
      <v-btn class="mx-2" fab large outlined color="white" v-if="isAudio" @click="toggleAudio">
        <v-icon color="white">fa-microphone</v-icon>
      </v-btn>
      <v-btn class="mx-2" fab large color="primary" v-else @click="toggleAudio">
        <v-icon color="white">fa-microphone-slash</v-icon>
      </v-btn>
      <v-btn v-if="!isPractitionerAndRoomNotStarted" class="mx-2" fab large color="error" @click="hangup">
        <v-icon color="white">mdi-phone-hangup</v-icon>
      </v-btn>
      <v-btn class="mx-2" fab large outlined color="white" @click="toggleVideo" v-if="isVideo">
        <v-icon color="white">mdi-video</v-icon>
      </v-btn>
      <v-btn class="mx-2" fab large color="primary" @click="toggleVideo" v-else>
        <v-icon color="white">mdi-video-off-outline</v-icon>
      </v-btn>
    </v-flex>
    <Confirm
      :loading="loading"
      :dialog="dialog"
      :title="$t('visits.finish.title')"
      :text="$t('visits.finish.text')"
      :confirmText="$t('visits.finish.button')"
      :cancelText="$t('general.dialog.cancel')"
      @toggleDialog="toggleDialog"
      @confirm="finish"
    />
  </v-flex>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

import { snackBarEventBus, snackBarEventName } from "../../eventBuses/snackBar.eventBus";
import { RolesEnum } from "../../types/Roles.enum";
import Confirm from "../shared/Confirm.vue";

export default {
  props: {
    participant: Object,
  },
  components: {
    Confirm,
  },
  data() {
    return {
      dialog: false,
      loading: false,
    };
  },
  computed: {
    ...mapGetters("videoRoom", ["isVideo", "isAudio", "roomIsReady"]),
    ...mapGetters(["role"]),
    isPractitionerAndRoomNotStarted() {
      return this.role === RolesEnum.Practitioner && !this.roomIsReady;
    },
  },
  methods: {
    ...mapActions("videoRoom", ["finishRoom"]),
    ...mapMutations("videoRoom", ["setIsVideo", "setIsAudio"]),
    toggleVideo() {
      this.setIsVideo(!this.isVideo);
      this.$emit("onToggleVideo");
    },
    toggleAudio() {
      this.setIsAudio(!this.isAudio);
      this.$emit("onToggleAudio");
    },
    toggleDialog() {
      this.dialog = !this.dialog;
    },
    async hangup() {
      if (this.role === RolesEnum.Practitioner) {
        this.toggleDialog();
      } else {
        await this.$router.push({ name: "patientHome" });
      }
    },
    async finish() {
      this.loading = true;
      try {
        await this.finishRoom();
      } catch (e) {
        snackBarEventBus.$emit(snackBarEventName, { message: e.message || e, type: "error" });
      }
      this.toggleDialog();
      this.loading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.controls {
  width: 100%;
  position: absolute;
  padding: 2em;
  bottom: 57px;
  z-index: 3;

  @media (max-width: 767.98px) {
    bottom: 119px;
  }

  .settings {
    position: absolute;
    z-index: 1;
    left: 20px;
  }
  .control-settings {
    position: absolute;
    width: 100%;
    left: 0;
    top: 28px;
    text-align: center;
  }
}
</style>
